import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME } from 'QuickflowsApp/ts/constants';

import { UrlsService } from 'Angular/services/core/urls.service';
import { CookieService } from 'ngx-cookie-service';

import { MultiSelectQuickflowsComponent } from './multi-select-quickflows.component';
import { SingleSelectQuickflowsComponent } from './single-select-quickflows.component';

/**
 *
 * Quickflows Menu Component
 *
 * Controls the single select and multi select quickflow tabs.
 *
 * Input Properties:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *   securityName: The security name to initialize this component with, e.g. Vanguard Financials Index Admiral
 *   securityUrl: The security url to navigate e.g.  /mutual_funds/M:VFAIX
 *
 */

@Component({ standalone: false, selector: 'ycn-quickflows-menu', templateUrl: './quickflows-menu.template.html' })
export class QuickflowsMenuComponent implements OnInit {
    @Input() displaySecurityId?: string;

    @Input() securityId?: string;

    @Input() securityName?: string;

    @Input() securityUrl?: string;

    @ViewChild(MultiSelectQuickflowsComponent) multiSelectTab!: MultiSelectQuickflowsComponent;

    @ViewChild(SingleSelectQuickflowsComponent) singleSelectTab!: SingleSelectQuickflowsComponent;

    isMenuOpened: boolean = false;

    showSingleSecurityQuickflowsTab: boolean = true;

    userPreferencesUrl: string = '';

    constructor(private cookieService: CookieService, private urlsService: UrlsService) {}

    ngOnInit(): void {
        this.setQuickflowMenuTab();
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.PROFILE_COMMUNICATIONS;
    }

    setQuickflowMenuTab(): void {
        const onSingleSecurityTabCookie = this.cookieService.get(QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME);
        if (onSingleSecurityTabCookie) {
            this.showSingleSecurityQuickflowsTab = JSON.parse(onSingleSecurityTabCookie);
        }
    }

    setQuickflowMenuTabCookie(): void {
        this.cookieService.set(
            QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME,
            this.showSingleSecurityQuickflowsTab.toString(),
            { path: '/' }
        );
    }

    focusOnSecurityInput(): void {
        setTimeout(() => {
            if (this.showSingleSecurityQuickflowsTab && this.singleSelectTab) {
                this.singleSelectTab.focusAutocompleter();
            } else if (!this.showSingleSecurityQuickflowsTab && this.multiSelectTab) {
                this.multiSelectTab.focusAutocompleter();
            }
        });
    }

    toggleQuickflowTab(): void {
        this.showSingleSecurityQuickflowsTab = !this.showSingleSecurityQuickflowsTab;
        this.setQuickflowMenuTabCookie();
        this.focusOnSecurityInput();
    }
}
